import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import { useMobile } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { LayerLogo } from '../LayerLogo/LayerLogo';
import { Marks } from '../Marks/Marks';
import { getItemUrl } from './utils';
import './Row.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('search-row');
export function Row(_ref) {
  var item = _ref.item,
    logo = _ref.logo,
    icon = _ref.icon,
    title = _ref.title,
    description = _ref.description,
    type = _ref.type,
    subtype = _ref.subtype,
    className = _ref.className,
    logoClassName = _ref.logoClassName,
    onClick = _ref.onClick,
    onMarkClick = _ref.onMarkClick,
    view = _ref.view;
  var _useMobile = useMobile(),
    _useMobile2 = _slicedToArray(_useMobile, 1),
    mobile = _useMobile2[0];
  var onClickCallback = useCallback(function () {
    return onClick === null || onClick === void 0 ? void 0 : onClick(item);
  }, [item, onClick]);
  var onMarkClickCallback = useCallback(function (mark) {
    return onMarkClick === null || onMarkClick === void 0 ? void 0 : onMarkClick(mark, item);
  }, [item, onMarkClick]);
  var id = item.id,
    layer = item.layer;
  var descriptionContent = description || /*#__PURE__*/_jsx(Highlight, {
    text: item.description
  });
  var isMobileView = view === 'mobile';
  var showMarks = !isMobileView && !mobile;
  var content = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: b('logo', logoClassName),
      children: logo !== null && logo !== void 0 ? logo : /*#__PURE__*/_jsx(LayerLogo, {
        icon: icon,
        layer: layer,
        type: type,
        subtype: subtype,
        size: isMobileView ? 's' : 'm'
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: b('info'),
      children: [/*#__PURE__*/_jsx("div", {
        className: b('title'),
        children: title !== null && title !== void 0 ? title : /*#__PURE__*/_jsx(Highlight, {
          text: item.title
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: b('extra'),
        children: [descriptionContent && /*#__PURE__*/_jsx("div", {
          className: b('description'),
          children: descriptionContent
        }), showMarks && /*#__PURE__*/_jsx(Marks, {
          onItemClick: onMarkClickCallback,
          className: b('marks')
        })]
      })]
    })]
  });
  var url = getItemUrl(item);
  return /*#__PURE__*/_jsx("a", {
    href: url,
    className: b({
      layer: layer,
      marks: showMarks,
      mobile: isMobileView
    }, className),
    onClick: onClickCallback,
    children: content
  }, id + layer);
}
// #sourceMappingURL=Row.js.map